<template>
  <div id="main">
    <img class="logo" src="@/assets/shipping/logo.png">
    <div class="container contents">
      <div class="row h-100">
          <div class="col-4 h-100 tip">
            <img class="step-image" :src="imageSrc">
          </div>
          <div class="col-6 h-100 tip align-items-center">
            <div>
              <p class="title">
                <span class="step">{{stepStatus.Label}}</span>
                <span class="sub-title">{{stepStatus.Title}}</span>
              </p>
              <p v-for="(note, index) in stepStatus.Notes" :key="index" class="notes">
                {{note}}
              </p>
            </div>
          </div>

          <div class="col-2 tip">
            <div class="next-button" @click="clickedNextBtn">
              {{stepStatus.Next}}
            </div>
          </div>

      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import createStore from '@/store/index.js'
import { useRouter } from 'vue-router'
import { ShippingStep } from '@/const/const'

export default defineComponent({
  setup () {
    const store = createStore
    const router = useRouter()

    const stepStatus = computed(() => {
      return store.getters.stepStatus
    })

    const imageSrc = computed(() => {
      return store.getters.shippingImage
    })

    const clickedNextBtn = () => {
      // store.commit('changedStep')
      switch (stepStatus.value.Index) {
        case ShippingStep.Step1.Index:
          // state.stepStatus = ShippingStep.Step2
          router.push({ name: 'Step2' })
          break
        case ShippingStep.Step2.Index: {
          store.commit('updateShippingStep2ToStep3')
          router.push({ name: 'Step3' })
          break
        }
        case ShippingStep.Step3.Index:
          router.push({ name: 'Step4' })
          break
        case ShippingStep.Step4.Index:
          // 完了処理
          break
      }
    }
    return {
      imageSrc,
      stepStatus,
      clickedNextBtn
    }
  }
})
</script>

<style lang="scss" scoped>
  #main {
    position: relative;
    width: 100%;
    height: 100%;
    .logo {
      position: absolute;
      left: 5%;
      bottom: 0;
      height: 60%;
      object-fit: contain;
    }
    .contents {
      height: 100%;
    }
    .tip {
      background: white;
      .step-image {
        height: 90%;
        object-fit: contain;
      }
      .title {
        padding-top: 1rem;
        text-align: left;
        font-size: large;
        font-weight: bold;
        .step {
          color: black;
        }
        .sub-title {
          padding-left: 2rem;
          color: #F0811E;
        }
      }
      .notes {
        text-align: left;
      }
    }

    .next-button {
      cursor: pointer;
      position: absolute;
      bottom: 1rem;
      padding-left: 2rem;
      padding-right: 2rem;
      background: #C4E1F2;
      border-radius: 10px;
      border: #89C3E5 5px solid;
    }
  }
</style>
